import { createAction, props } from "@ngrx/store";
import { Permission } from "@modules/permissions/permission.interface";

export const PermissionAddAction = createAction(
  '[Permissions] permission add',
  props<{ permission: Partial<Permission> }>()
);

export const PermissionAddedAction = createAction(
  '[Permissions] permission created',
  props<{ permission: Permission }>()
);

export const PermissionErrorAddingAction = createAction(
  '[Permissions] Error Adding Permission'
)

export const PermissionRemoveAction = createAction(
  '[Permissions] remove permission',
  props<{ permissionId: string }>()
);

export const PermissionRemovedAction = createAction(
  '[Permissions] permission removed',
  props<{ permissionId: string }>()
);

export const PermissionErrorRemovingAction = createAction(
  '[Permissions] Error Removing Permission'
);

export const PermissionUpdateAction = createAction(
  '[Permissions] update permission',
  props<{ permission: Permission }>()
);

export const PermissionUpdatedAction = createAction(
  '[Permissions] permission updated',
  props<{ permission: Permission }>()
);

export const PermissionErrorUpdatingAction = createAction(
  '[Permissions] Error Updating Permission'
);
